import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import React from 'react';

const SimpleAlert = ({
  open,
  onClose,
  children: textContent,
  buttonLabel = 'OK',
  title = 'Aviso',
}) => {
  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <>
      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <DialogTitle disableTypography>
          <Typography variant="subtitle1">{title}</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div" gutterBottom>
            {textContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            {buttonLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SimpleAlert;
